var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"loading-back"},[_c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-icon"}),_c('div',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.text))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }